import { areShopFiltersFetched } from './selectors';
import Http from '../../../../http';
import { getActiveBrandId } from '../../../../auth/selectors';
import {
  FETCH_SHOPS_FOR_FILTER,
  SHOP_FILTER_DESELECT_ALL,
  SHOP_FILTER_SELECT_ALL,
  UPDATE_SHOP_FILTER,
} from './constants';

const fetchShopFilters = shops => ({
  type: FETCH_SHOPS_FOR_FILTER,
  payload: shops,
});

export const fetchShopsIfNotFetched = () => async (dispatch, getState) => {
  const state = getState();

  if (areShopFiltersFetched(state)) {
    return true;
  }
  const brandId = getActiveBrandId(state);
  const brand = await Http.get(`/brand/${brandId}?include=shops`);
  return dispatch(fetchShopFilters(brand.shops));
};

export const updateShopFilter = payload => ({
  type: UPDATE_SHOP_FILTER,
  payload,
});

export const selectAll = () => ({
  type: SHOP_FILTER_SELECT_ALL,
});

export const deselectAll = () => ({
  type: SHOP_FILTER_DESELECT_ALL,
});
